<template>
  <div>
    <b-card class="mt-3">
      <h4>Список почт для перенаправления писем, отправленных в тех. поддержку</h4>
      <textarea
        class="w-100"
        rows="3"
        name="emails"
        v-model = "mailList"
        placeholder="Введите список почт, разделенных знаком ','"/>
      <div class="text">Введите список почт, разделенных знаком ','</div>
      <b-btn variant="primary" class="mt-2" @click="accept">Подтвердить</b-btn>
    </b-card>

    <b-card class="mt-3">
      <h4>Написать письмо всем ученикам</h4>
      <textarea
        class="w-100"
        rows="3"
        name="emails"
        v-model = "massMailTheme"
        placeholder="Введите тему"/>
      <textarea
        class="w-100"
        rows="3"
        name="emails"
        v-model = "massMailMsg"
        placeholder="Введите сообщение"/>
      <b-btn variant="primary" class="mt-2" @click="openMassMailConfirmModal">Отправить</b-btn>
    </b-card>

    <b-card class="mt-3">
      <h4>Обновление статистики</h4>
      <div class="mt-4">Текущий год: <strong>{{year - 1}}</strong> /
        <input type="number"
               v-model="year"
               min="2020"
               max="2100"
               class="year">
        <b-btn variant="primary" class="ml-4" @click="confirmYear">Сохранить</b-btn>
        <b-btn variant="primary" class="ml-4"
               @click="confirmUpdateYear">Пересчитать текущий год</b-btn>
      </div>
    </b-card>

    <b-card class="mt-3">
      <h4>Обновление года для выбора вуза</h4>
      <div class="mt-4">Текущий год: <strong>{{univerYear - 1}}</strong> /
        <input type="number"
               v-model="univerYear"
               min="2020"
               max="2100"
               class="year">
        <b-btn variant="primary" class="ml-4" @click="showConfirmUniverYearModal">Сохранить</b-btn>
      </div>
    </b-card>
    <b-modal size="lg" id="setStatConfirmModal" title="Подтверждение текущего года" @ok="confirm">
      <div>
        Вы уверены, что хотите установить <strong>{{year - 1}}</strong> /
        <strong>{{year}}</strong> год текущим для статистики?
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary">
          Подтвердить
        </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>

    <b-modal
      size="lg"
      id="setUniverYearConfirmModal"
      title="Подтверждение текущего года"
      @ok="confirmUniverYear"
    >
      <div>
        Вы уверены, что хотите установить <strong>{{univerYear - 1}}</strong> /
        <strong>{{univerYear}}</strong> год текущим для выбора вуза?
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary">
          Подтвердить
        </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="updateStatModal" title="Обновление статистики" @ok="updateYear">
      <div>
        Текущий год <strong>{{year}}</strong> будет пересчитан в соответствии с количеством
        активных учеников в классах. Подтвердить изменения?
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary">
          Подтвердить
        </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>

    <b-modal size="lg" id="confirmSendMassMail" title="Подтверждение отправки" @ok="sendMassMail">
      <div>
        Вы уверены, что хотите отправить сообщение?
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button @click="ok()" variant="primary">
          Подтвердить
        </b-button>
        <b-button @click="cancel()"> Отмена </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import notsApi from '@/api/notifications'
import statisticsApi from '@/api/statistics'
import RecommendationAPI from '@/api/recommendation'
import { regexp } from '@/config/regexp'
import MessageApi from '@/api/messages'
import DeleteModal from '@/components/ui/modals/DeleteModal.vue'

export default {
  name: 'ConfigForm',
  components: {
    DeleteModal
  },
  data() {
    return {
      mailList: '',
      massMailTheme: '',
      massMailMsg: '',
      year: 0,
      univerYear: 0
    }
  },
  async created() {
    this.mailList = (await notsApi.getRedirectEmails()).data.emails.join(',')
    this.year = (await statisticsApi.getStatisticYear()).data.year
    this.univerYear = (await RecommendationAPI.getYear()).data.year
  },
  methods: {
    ...mapActions({
      pushToasts: 'toasts/pushToasts'
    }),
    openMassMailConfirmModal() {
      this.$bvModal.show('confirmSendMassMail')
    },
    sendMassMail() {
      MessageApi.sendMassMail(this.massMailTheme, this.massMailMsg)
    },
    checkEmails(emails) {
      return !emails.find((email) => !regexp.email.test(email))
    },
    accept() {
      const emails = _.uniq(
        this.mailList.split(',').map((email) => email.trim()),
      )
      if (this.checkEmails(emails)) {
        notsApi.setRedirectEmails(emails).then((res) => {
          if (res.data.message === 'ok') {
            this.pushToasts({
              time: 3,
              title: 'Обновлено',
              message: 'Список email-ов обновлен'
            })
          } else {
            this.pushToasts({
              error: true,
              time: 5,
              title: 'Ошибка ввода',
              message: 'Проверьте правильность ввода email-ов'
            })
          }
        })
      } else {
        this.pushToasts({
          error: true,
          time: 5,
          title: 'Ошибка ввода',
          message: 'Проверьте правильность ввода email-ов'
        })
      }
    },
    confirm() {
      statisticsApi.setStatisticYear(this.year).then((res) => {
        if (res.data.message === 'ok') {
          this.pushToasts({
            time: 3,
            title: 'Обновлено',
            message: 'Статистика обновлена'
          })
        } else {
          this.pushToasts({
            error: true,
            time: 5,
            title: 'Ошибка',
            message: 'Ошибка установки года'
          })
        }
      })
    },
    confirmUniverYear() {
      RecommendationAPI.setYear(this.univerYear).then((res) => {
        if (res.data.message === 'ok') {
          this.pushToasts({
            time: 3,
            title: 'Обновлено',
            message: 'Год для выбора вуза обновлен'
          })
        } else {
          this.pushToasts({
            error: true,
            time: 5,
            title: 'Ошибка',
            message: 'Ошибка установки года'
          })
        }
      })
    },
    confirmYear() {
      this.$bvModal.show('setStatConfirmModal')
    },
    showConfirmUniverYearModal() {
      this.$bvModal.show('setUniverYearConfirmModal')
    },
    confirmUpdateYear() {
      this.$bvModal.show('updateStatModal')
    },
    updateYear() {
      statisticsApi.updateStatisticYear().then((res) => {
        if (res.data.message === 'ok') {
          this.pushToasts({
            time: 3,
            title: 'Обновлено',
            message: 'Установлена актуальная статистика'
          })
        } else {
          this.pushToasts({
            error: true,
            time: 5,
            title: 'Ошибка',
            message: 'Ошибка установки статистики'
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.text{
  color: rgba(0, 0,0, 0.5);
  font-style: italic;
}
.year{
  width: 5em;
}


</style>
